@if (errors) {
  @for (key of errorKeys; track key) {
    @if (customErrorMessages && customErrorMessages[key]) {
      <ppl-input-error>{{ customErrorMessages[key] }}</ppl-input-error>
    } @else {
      @switch (key) {
        @case ('required') {
          <ppl-input-error>
            @if (errors[key].minItems) {
              Check at least {{ errors[key].minItems }} option(s).
            } @else {
              {{ thisFieldIsRequired }}
            }
          </ppl-input-error>
        }
        @case ('email') {
          <ppl-input-error>{{ invalidEmailFormat }}</ppl-input-error>
        }
        @case ('url') {
          <ppl-input-error>{{ invalidUrlFormat }}</ppl-input-error>
        }
        @case ('secureUrl') {
          <ppl-input-error>{{ invalidSecureUrlFormat }}</ppl-input-error>
        }
        @case ('invalidOption') {
          <ppl-input-error>{{ invalidOptionSelected }}</ppl-input-error>
        }
        @case ('ownerUnitMembership') {
          <ppl-input-error>{{ ownerNotHaveAccessSalesUnit }}</ppl-input-error>
        }
        @case ('userNotMemberOfSalesUnit') {
          <ppl-input-error>{{ userNotMemberOfSalesUnit }}</ppl-input-error>
        }
        @case ('min') {
          <ppl-input-error>{{ invalidMinimalValue }} {{ errors[key].min }}</ppl-input-error>
        }
        @case ('minDateValue') {
          <ppl-input-error>{{ invalidMinDate }} {{ errors[key] }}</ppl-input-error>
        }
        @case ('maxDateValue') {
          <ppl-input-error>{{ invalidMaxDate }} {{ errors[key] }}</ppl-input-error>
        }
        @case ('range') {
          <ppl-input-error>{{ invalidValueRange }} {{ errors[key][0] }}, {{ errors[key][1] }}&gt;</ppl-input-error>
        }
        @case ('logic') {
          <ppl-input-error>{{ invalidFieldValue }} {{ errors[key] }}</ppl-input-error>
        }
        @case ('pattern') {
          <ppl-input-error>{{ invalidRequiredPattern }} {{ errors[key].requiredPattern }}</ppl-input-error>
        }
        @case ('integer') {
          <ppl-input-error>{{ invalintIntegerValue }}</ppl-input-error>
        }
        @case ('number') {
          <ppl-input-error>{{ invalidNumberValue }}</ppl-input-error>
        }
        @case ('minMaxValue') {
          <ppl-input-error>{{ minHasToBeSmallerThanMax }}</ppl-input-error>
        }
        @case ('atLeastOneOption') {
          <ppl-input-error>{{ atLeastOneSelected }}</ppl-input-error>
        }
        @case ('password') {
          <ppl-input-error>
            {{ invalidPassword }}
          </ppl-input-error>
        }
        @case ('maxlength') {
          <ppl-input-error>{{ invalidLength }} {{ errors[key].requiredLength }}, {{ actualLength }} {{ errors[key].actualLength }}.</ppl-input-error>
        }
        @case ('minlength') {
          <ppl-input-error>{{ invalidMinLength }} {{ errors[key].requiredLength }}, {{ actualLength }} {{ errors[key].actualLength }}.</ppl-input-error>
        }
        @case ('maxItemCount') {
          <ppl-input-error>{{ invalidCount }} {{ errors[key].requiredLength }}, {{ actualCount }} {{ errors[key].actualLength }}.</ppl-input-error>
        }
        @case ('minItemCount') {
          <ppl-input-error>{{ invalidMinCount }} {{ errors[key].requiredLength }}, {{ actualCount }} {{ errors[key].actualLength }}.</ppl-input-error>
        }
        @case ('custom') {
          <ppl-input-error>{{ errors[key] }}</ppl-input-error>
        }
        @case ('productsServicesPipelineUnavailable') {
          <ppl-input-error>{{ highlightedProductsAreNotAvailable }}</ppl-input-error>
        }
        @case ('productsServicesInvalidProducts') {
          <ppl-input-error>{{ productsServicesInvalidProducts }}</ppl-input-error>
        }
        @case ('productsServicesInvalidApiProducts') {
          <ppl-input-error>{{ productsServicesInvalidProducts }}</ppl-input-error>
        }
        @case ('productsServicesInvalidPricelist') {
          <ppl-input-error>{{ productsServicesInvalidProducts }}</ppl-input-error>
        }
        @case ('productsServicesCurrencyUnavailable') {
          <ppl-input-error>{{ highlightedCurrencyIsNotAvailable }}</ppl-input-error>
        }
        @case ('productsServicesPriceListUnavailable') {
          <ppl-input-error>{{ highlightedPriceListIsNotAvailable }}</ppl-input-error>
        }
        @case ('dayIsNotSelected') {
          <ppl-input-error>{{ dayIsNotSelected }}</ppl-input-error>
        }
        @case ('firstOrLastNameRequired') {
          <ppl-input-error>{{ firstOrLastNameRequired }}</ppl-input-error>
        }
        @case ('invalidHeaderKey') {
          <ppl-input-error>{{ invalidHeaderKey }}</ppl-input-error>
        }
        @case ('invalidHeaderValue') {
          <ppl-input-error>{{ invalidHeaderValue }}</ppl-input-error>
        }
        @case ('duplicateHeaders') {
          <ppl-input-error>{{ duplicateHeaders }}</ppl-input-error>
        }
        @case ('invalidRollupNesting') {
          <ppl-input-error>{{ invalidRollupNesting }}</ppl-input-error>
        }
        @case ('requiredDependentEntity') {
          <ppl-input-error>{{ requiredDependentEntity }}</ppl-input-error>
        }
        @case ('invalidPageLinkFormat') {
          <ppl-input-error>{{ invalidPageLinkFormat }}</ppl-input-error>
        }
        @case ('takenPageLink') {
          <ppl-input-error>{{ takenPageLink }}</ppl-input-error>
        }
        @case ('processInfiniteLoop') {
          <ppl-input-error>{{ processInfiniteLoop }}</ppl-input-error>
        }
        @case ('processDeleted') {
          <ppl-input-error>{{ processDeleted }}</ppl-input-error>
        }
        @case ('lookupFieldDeleted') {
          <ppl-input-error>{{ lookupFieldDeleted }}</ppl-input-error>
        }
        @case ('filesUploading') {
          <ppl-input-error>{{ filesUploading }}</ppl-input-error>
        }
        @case ('itemUnavailable') {
          <ppl-input-error>{{ itemUnavailable }}</ppl-input-error>
        }
        @case ('selectedValueDoesNotExist') {
          <ppl-input-error>{{ selectedValueDoesNotExist }}</ppl-input-error>
        }
        @case ('filterFormulaError') {
          <ppl-input-error>{{ errors[key].message }}</ppl-input-error>
        }
        @default {
          <ppl-input-error>{{ invalidFieldValue }} {{ errors[key] | json }}</ppl-input-error>
        }
      }
    }
  }
}
